import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rx-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})
export class TextareaComponent implements ControlValueAccessor {
  /** Label text */
  @Input() public label?: string;

  /** Placeholder text */
  @Input() public placeholder?: string;

  /** Disabled state */
  @Input() public disabled?: boolean;

  /** Readonly state */
  @Input() public readonly?: boolean;

  /** Input value */
  @Input() public value?: string = '';

  @Input() public rows = 4;
  @Input() public cols?: number;
  @Input() public maxLength?: number;
  @Input() public minLength?: number;

  public onTouched: () => void;
  public onChange: (value: any) => void;

  public writeValue = (value: any) => {
    this.value = value;
  };
  public registerOnChange = (fn: (val: any) => void) => (this.onChange = fn);
  public registerOnTouched = (fn: () => void) => (this.onTouched = fn);
  
}
